import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M11.68 5c-3.787 0-7.255 2.371-9.478 6.242-.27.47-.27 1.047 0 1.516C4.425 16.63 7.893 19 11.68 19c3.786 0 7.255-2.371 9.477-6.242.27-.47.27-1.046 0-1.516C18.935 7.37 15.467 5 11.68 5ZM.468 10.246C2.945 5.931 6.994 3 11.68 3c4.685 0 8.734 2.93 11.212 7.246a3.522 3.522 0 0 1 0 3.508C20.414 18.069 16.365 21 11.68 21 6.994 21 2.945 18.07.468 13.754a3.522 3.522 0 0 1 0-3.508ZM11.68 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
